import Services from "../../../services";

class UnitOrganisasiApi {
  get() {
    return Services.get("/unit_organisasi");
  }

  getPage(page, dataLength, key) {
    return Services.get(`/unit_organisasi/page/?per_page=${dataLength}&page=${page}&q=${key}`);
  }

  getDropdown() {
    return Services.get("/unit_organisasi/dropdown");
  }

  getParent(id) {
    return Services.get("/unit_organisasi/dropdown?level_hirarki_unit_organisasi=" + id);
  }

  kode() {
    return Services.get("/unit_organisasi/no_baru");
  }

  search(key) {
    return Services.get("/unit_organisasi/page/?per_page=10&page=1&q=" + key);
  }

  show(value) {
    return Services.put("/unit_organisasi/show", value);
  }

  hide(value) {
    return Services.put("/unit_organisasi/hide", value);
  }

  create(value) {
    return Services.post("/unit_organisasi", value);
  }

  update(value) {
    return Services.put("/unit_organisasi", value);
  }

  delete(value) {
    return Services.post("/unit_organisasi/delete", value);
  }
  checkDuplicateNama(params) {
    return Services.get('/unit_organisasi/check_duplicate/', { params })
  }

}

export default new UnitOrganisasiApi();
